'use client';

import { useRouter } from 'next/navigation';
import { LogOut } from 'lucide-react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { logout } from '@/lib/actions';

export default function LogoutButton() {
  const router = useRouter();

  const handleLogout = async () => {
    await logout();
    router.refresh();
  };

  return (
    <DropdownMenuItem
      onSelect={(e) => {
        e.preventDefault();
        handleLogout();
      }}
      className="hover:cursor-pointer"
    >
      <div className="w-full flex gap-2">
        <LogOut />
        خروج از حساب کاربری
      </div>
    </DropdownMenuItem>
  );
}
